'use client'

import { type FC, type ReactNode } from 'react'

import { useNextPathname } from '../../../next-pathname'
import { storyAccessorIsAllFromCategoryPath } from '../../model/storyAccessors/storyAccessorIsAllFromCategoryPath'

import { StoryblokCategoryProductSearch } from './components/StoryblokCategoryProductSearch'

export const StoryblokAkeneoCategoryPageContent: FC<{
  children: Awaited<ReactNode>
}> = ({ children }) => {
  const pathname = useNextPathname()

  if (storyAccessorIsAllFromCategoryPath(pathname)) {
    return (
      <section className="container">
        <StoryblokCategoryProductSearch />
      </section>
    )
  }

  return children
}
